import { StakeholderService } from 'src/app/core/services/stakeholder.service';
import {Component, Input} from '@angular/core';
import {ServiceOrder} from '@secca/shared/models/service-order/service-order';
import {ServiceOrderHoverExtensionComponent} from '@secca/case/components/case-plans/plan/service-order-hover/service-order-hover-extension-component';
import {CaseStakeholder} from '@secca/shared/models/caseStakeholder';
import {StakeholderTypeEnum} from '@secca/shared/models/enums';
import {RegularFlightNonMedicalServiceOrderExtension} from '@secca/shared/models/service-order/regular-flight-non-medical-service-order-extension';

@Component({
    selector: 'app-regular-flight-non-medical-service-order-hover',
    templateUrl: './regular-flight-non-medical-service-order-hover.component.html',
    styleUrls: ['./regular-flight-non-medical-service-order-hover.component.scss'],
    standalone: false
})
export class RegularFlightNonMedicalServiceOrderHoverComponent implements ServiceOrderHoverExtensionComponent {
  @Input() serviceOrder: ServiceOrder;
  @Input() caseStakeholders: CaseStakeholder[];
  @Input() providerName: string;

  get extension(): RegularFlightNonMedicalServiceOrderExtension {
    return this.serviceOrder.extension as RegularFlightNonMedicalServiceOrderExtension;
  }

  stakeholders: { firstName: string, surname: string, icon: string, gender: string, age: string }[];

  constructor(private stakeholderService: StakeholderService) {
  }

  onRefresh() {
    if (this.extension.stakeholderIds) {
      this.stakeholders = [];
      this.extension.stakeholderIds.forEach(stakeholderId => {
        const caseStakeholder = this.caseStakeholders.find(a => a.id === stakeholderId.toString());
        if (caseStakeholder != null) {
          this.stakeholders.push(this.createLocalStakeholder(caseStakeholder));
        }
      });
    }
  }

  private createLocalStakeholder(caseStakeholder: CaseStakeholder): any {
    let type = caseStakeholder.stakeholderType;
    if (caseStakeholder.coTraveller) {
      type = StakeholderTypeEnum.coTraveller;
    }
    return {
      firstName: caseStakeholder.person.firstName != null ? caseStakeholder.person.firstName : '',
      surname: caseStakeholder.person.surname != null ? caseStakeholder.person.surname : '',
      icon: this.stakeholderService.getStakeholderIconFullPath(type),
      gender: caseStakeholder.person.gender,
      age: caseStakeholder.person.age
    };
  }
}
